import { environment } from '../../environments/environment';

export function appEnv() {
    return environment.ENVIRONMENT.toLowerCase();
}

export function isProduction() {
    return appEnv() === "production";
}

export function isTesting() {
    return appEnv() === "testing";
}

export function isStaging() {
    return appEnv() === "staging";
}

export function isLocal() {
    return appEnv() === "local";
}